import { countValidator } from '@/utils/validate'

export const detailRule={
  count: [
    {
      validator: countValidator,
      trigger: 'change',
    },
  ]
}
export const dataRule={
  receiverId: [{
    required: true,
    message: `请选择收货方`,
    trigger: 'change',
  }],
  operateDate: [{
    required: true,
    message: '请选择发货时间',
    trigger: 'change',
  }]
}
